import { ChangeDetectionStrategy, Component, inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { BehaviorSubject } from 'rxjs';

import {
  ButtonIconComponent,
  DialogComponent,
  ScrollerComponent,
  TreeSelectComponent,
} from '@blaze-shared/shared-ui';

import { ApiBuilderAction } from '../api-builder.model';

export interface ResultSchemaDialogData {
  action: ApiBuilderAction;
}

@Component({
  selector: 'blaze-result-schema-page',
  imports: [
    ButtonIconComponent,
    DialogComponent,
    MatIconModule,
    ScrollerComponent,
    TreeSelectComponent,
  ],
  templateUrl: './result-schema-dialog.component.html',
  styleUrls: ['./result-schema-dialog.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ResultSchemaDialogComponent implements OnInit {
  private readonly dialogData = inject<ResultSchemaDialogData>(MAT_DIALOG_DATA);
  private readonly dialogRef = inject<MatDialogRef<ResultSchemaDialogComponent>>(MatDialogRef);

  data$ = new BehaviorSubject<any>(undefined);
  action = this.dialogData.action;

  ngOnInit(): void {
    this.data$.next(this.action.data.resultColumns);
  }

  returnToBuilder(): void {
    this.dialogRef.close();
  }
}
